<body>
            <div class="container-fluid" [ngClass]="{'dark-bg' : isDark }">
              <div class="row">
                <div class="col-12">                
                  <div class="invoice p-3 mb-3"> 

                    <div class="row justify-content-center">
                        <h6>Cash Flow Statement</h6> 
                    </div>
      
                    <!-- Tabele row -->
                    <div class="row">
                    <div class="col-12">
                    <div class="card" [ngClass]="{'dark-bg' : isDark }">                  
                     <div class="card-body">

                       <div class="row pb-2">
                        <div class="col-3 input-group">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text" [ngClass]="{'dark-bg' : isDark }"><i class="fa fa-calendar-o"></i></span>
                                </div>
                                <input type="text" [ngClass]="{'dark-bg' : isDark }" [(ngModel)]="fromDate" bsDatepicker [bsConfig]="datepickerConfig" class="form-control" placeholder="From Date">
                              </div>
                          </div>
                        <div class="col-3 input-group">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text" [ngClass]="{'dark-bg' : isDark }"><i class="fa fa-calendar-o"></i></span>
                                </div>
                                <input type="text" [ngClass]="{'dark-bg' : isDark }" [(ngModel)]="toDate" bsDatepicker [bsConfig]="datepickerConfig" class="form-control" placeholder="To Date">
                              </div>
                        </div>
                        <div class="col-3 input-group">
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text" [ngClass]="{'dark-bg' : isDark }"><i class="fa fa-vcard"></i></span>
                            </div>
                            <select [ngClass]="{'dark-bg' : isDark }"  [(ngModel)]="bankAccount"  class="form-control">        
                              <option [ngValue]="null">-Select-</option>
                              <option *ngFor="let item of bankAccountList" [value]="item.AccountName">
                                {{item.AccountName}}
                              </option>
                          </select>
                          </div>
                      </div>
                        <div class="col-3">
                            <button (click)="viewBtnClicked()" mat-raised-button>View</button>
                            <button (click)="clearBtnClicked()" mat-raised-button class="ml-2">Clear</button>                         
                        </div>
                    </div>

                      <div class="col-12 table-responsive scrollable" id="expReport">
                        <table class="table"  [ngClass]="{'dark-bg' : isDark }">
                          <thead>
                          <tr >                          
                            <th>TransNo</th>
                            <th>CreatedBy</th>
                            <th>Type</th>
                            <th>Date</th>
                            <th>PaymentType</th>
                            <th>Description</th>
                            <th>Account</th>
                            <th>RefNo</th>
                            <th>Amount</th>                     
                          </tr>
                          </thead>
                          <tbody>
                            <tr class="table-active">
                                <td colspan="8" class="text-right text-bold">Opening Balance {{ openingBalText }} : </td>
                                <td class="text-right text-bold">{{ openingBalance | number:'1.2-2'}}</td>
                            </tr>  
                            <tr *ngFor="let item of filteredList">    
                                <td>{{item[0]}}</td>
                                <td>{{item[1]}}</td> 
                                <td><span class="badge" [ngClass]="{'badge-success' : item[2]==='Receipt', 'badge-info' : item[2]==='Payment', 'badge-warning' : item[2]==='Expense','badge-primary' : item[2]==='Deposited','badge-danger' : item[2]==='Withdrawn','badge-secondary' : item[2]==='Transfer','badge-dark' : item[2]==='Commission'}" >{{item[2]}}</span></td>
                                <td>{{item[3] | date :'y-MM-dd'}}</td>
                                <td>{{item[4]}}</td>             
                                <td>{{item[5]}}</td>
                                <td>{{item[6]}}</td>
                                <td>{{item[7]}}</td>
                                <td class="text-right">{{item[8] | number:'1.2-2'}}</td>
                            </tr> 
                          <tr class="table-active">
                            <td colspan="8" class="text-right text-bold">Closing Balance {{closingBalText}} :</td>
                            <td class="text-right text-bold">{{getTotal() | number:'1.2-2'}}</td>
                          </tr>                                              
                          </tbody>
                        </table>
                      </div>
                      <!-- /.col -->
                     </div>
                    </div>
                    </div>
                    </div>
                    <!-- /.row -->
      
      
                    <!-- this row will not appear when printing -->
                    <div class="row no-print">
                      <div class="col-12">
                        <button [ngClass]="{'dark-bg' : isDark }" type="button"  (click)="savePDF('print')"  class="btn btn-default float-right"><i class="fas fa-print"></i> Print</button>      
                        <button [ngClass]="{'dark-bg' : isDark }" type="button" (click)="exportexcel()"  class="btn btn-default float-right"><i class="fa fa-file-excel-o" style="color:green"></i> Excel</button>      
                         <button [ngClass]="{'dark-bg' : isDark }" type="button"  (click)="savePDF('open')" class="btn btn-default float-right"><i class="fa fa-file-pdf-o" style="color:red"></i> PDF</button>                                                                                                                                                            
                      </div>
                    </div>


                  </div><!-- /.invoice -->                 
                </div><!-- /.col -->
              </div><!-- /.row -->
            </div><!-- /.container-fluid -->         
 </body>







